<template>
  <gg-modal :is-active="opened" @close="closeModal">
    <template v-slot:toolbar>
      {{ cr_guided.title }}
    </template>
    <template v-slot:body>
      <p class="body-1">
        {{ cr_guided.offer_msg }}
      </p>
    </template>
    <template v-slot:actions>
      <gg-btn secondary :loading="loadingDecline"  @click="decline">
        Decline Offer
      </gg-btn>
      <gg-btn primayr  :loading="loadingAccept" @click="accept">
        Accept Offer
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OfferModal',
  props: {
    opened: {
      required: true,
      type: Boolean
    },
  },
  data () {
    return {
      loadingDecline: false,
      loadingAccept: false,
    }
  },
  computed: {
    ...mapGetters(['cr_guided', 'cr_id'])
  },
  methods: {
    ...mapActions(['sendCREscalate', 'sendCRDeclined', 'reportError', 'reportSuccess']),
    async accept () {
      this.loadingAccept = true
      try {
        const response = await this.sendCREscalate()

        this.closeModal()
        // this.$router.push({ name: 'cancellation_details', params: { id: this.cr_id } })
        this.reportSuccess(response.resultmsg)
        this.$emit('accepted', response)
      } catch (e) {
        this.reportError(e)
      }
      this.loadingAccept = false
    },
    async decline () {
      try {
        this.loadingDecline = true

        await this.sendCRDeclined()

        this.closeModal()
        this.$emit('declined')
      } catch (e) {
        this.reportError(e)
      }
      this.loadingDecline = false
    },
    closeModal () {
      this.$emit('close')
    }
  }
}
</script>
